import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import { useChannelContext } from '../Channel/Context'
import { useContext } from './Context'
import { AttachFileButton } from './ChatButtons/AttachFileButton'
import { HorizontalStack } from '@ztechapps/webui.util'

export const ChatActionContainer = () => {
  const { components, ...rest } = useContext()
  const { attachments, addAttachments } = useChannelContext()

  return (
    <HorizontalStack gap={2} className="justify-content-between mt-1">
      <div className="flex-fill">
        <components.chatActions.leftContent {...rest} />
      </div>
      <ButtonGroup>
        <components.chatActions.otherButtons {...rest} />
        <AttachFileButton attachments={attachments} onAttach={addAttachments} disabled={rest.status?.sending} />
        <components.sendMessageButton {...rest} />
      </ButtonGroup>
    </HorizontalStack>
  )
}
